(function () {
  'use strict';
  function inWindow(slide, now) {
    var s = slide.dataset.start, e = slide.dataset.end;
    if (s) { var sd = new Date(s + 'T00:00:00'); if (now < sd) return false; }
    if (e) { var ed = new Date(e + 'T23:59:59'); if (now > ed) return false; }
    return true;
  }

  function init(root) {
    var now = new Date();
    var allSlides = Array.prototype.slice.call(root.querySelectorAll('[data-ab-slide]'));
    var slides = allSlides.filter(function (s) { return inWindow(s, now); });
    // Hide out-of-window slides permanently
    allSlides.forEach(function (s) { if (slides.indexOf(s) === -1) s.style.display = 'none'; });
    if (slides.length === 0) { root.style.display = 'none'; return; }

    var idx = 0;
    function show(i) {
      slides.forEach(function (s, j) { s.classList.toggle('is-active', i === j); });
    }
    show(0);

    var interval = parseInt(root.dataset.rotateMs, 10) || 5000;
    var autoplay = root.dataset.autoplay !== 'false' && slides.length > 1;
    var timer = null;
    function start() {
      if (!autoplay) return;
      stop();
      timer = setInterval(function () { idx = (idx + 1) % slides.length; show(idx); }, interval);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    var prev = root.querySelector('.ab-rotating__nav--prev');
    var next = root.querySelector('.ab-rotating__nav--next');
    if (prev) prev.addEventListener('click', function () { idx = (idx - 1 + slides.length) % slides.length; show(idx); start(); });
    if (next) next.addEventListener('click', function () { idx = (idx + 1) % slides.length; show(idx); start(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    if (slides.length > 1 && (prev || next)) {
      prev && prev.removeAttribute('hidden');
      next && next.removeAttribute('hidden');
    } else {
      prev && (prev.style.display = 'none');
      next && (next.style.display = 'none');
    }
    start();
  }

  function boot() {
    document.querySelectorAll('.ab-rotating').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Re-init on Shopify section editor changes
  document.addEventListener('shopify:section:load', boot);
})();
